const list = {
  path: 'list',
  component: resolve => require(['@/pages/admin/merchant/signing/yftWeChat/found/list'], resolve)
}

export default list
